import { OhiUniversityComponent } from './ohi-university/ohi-university.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Cerberus } from '@app/_helpers/Cerberus';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule); 

const routes: Routes = [
  {path: '', component: HomeComponent, canActivate:[Cerberus]},
  {path: 'university', component: OhiUniversityComponent, canActivate:[Cerberus]},
  {path: 'account', loadChildren: accountModule },
  {path: '*', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }